module.exports = __webpack_public_path__ + "img/2252.fca65aa0.gif";